/** Scroll a page section into view after route/query navigation. */
export function scrollToPageSection(elementId: string, behavior: ScrollBehavior = 'smooth'): void {
  requestAnimationFrame(() => {
    document.getElementById(elementId)?.scrollIntoView({ behavior, block: 'start' });
  });
}
